export default "__VITE_ASSET__BvvTJDfx__"